export default function cookieOptions() {
  let options = { expires: 365 };

  if (['uat', 'staging', 'production'].includes(import.meta.env.RAILS_ENV)) {
    options.secure = true;
  }

  return options;
}
